var map = {
	"./avatar-polly-base-full.png": 72945,
	"./avatar-polly-dino-full.png": 65222,
	"./avatar-polly-fall-full.png": 42147,
	"./avatar-polly-smoothie-full.png": 39399,
	"./avatar-polly-space-full.png": 16639,
	"./avatar-polly-spring-full.png": 41184,
	"./avatar-polly-summer-full.png": 17797,
	"./avatar-polly-winter-full.png": 32497
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17000;